import { useQuery } from '@tanstack/react-query';
import fetchAuditTrailSummary from '@data/auditTrail/fetchAuditTrailSummary';

const getAuditTrailSummary = () => {
    return useQuery({
        queryKey: ['audit-trail-summary'],
        queryFn: () => fetchAuditTrailSummary(),
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
    });
};

export default getAuditTrailSummary;
